import { SHAB_REDIRECT_MODAL_KEY } from "@website/widget/header/redirect-modal/hooks";
import { useSearchParams } from "next/navigation";

export const useRedirectModal = () => {
  const searchParameters = useSearchParams();

  return {
    isOpen: Boolean(searchParameters.get(SHAB_REDIRECT_MODAL_KEY)),
    redirectUrl: "/"
  };
};
